module.exports = __webpack_public_path__ + "img/lamp.be5030ca.webp";